import React from 'react';
import { 
	func, 
	array,
} from 'prop-types';
import {REQUESTING} from '../../../constants';
import algoliaSearchAdaptor from '../../../services/algoliaAdaptor';

class Container extends React.PureComponent {
	static propTypes = {
		render : func.isRequired,
		favs : array
	}

	constructor(props) {
		super(props);
		this.state = {
			favs : [],
			showAllRecipe : false,
			requestStatus : REQUESTING.NONE
		};
	}
    
    componentDidMount = ()=>{
    	const {favs=[]} = this.props;
    	algoliaSearchAdaptor.getObjects(favs,(error,res)=>{
    		if(error){
    			this.setState({
    				requestStatus : REQUESTING.FAIL
    			});
    			return;
    		}
    		const results = res.results.filter(fav=>Boolean(fav)).sort((l,r)=>{
    			if(l.lastUpdate && r.lastUpdate){
    				return r.lastUpdate - l.lastUpdate;
    			}
    			return l.name-r.name;
    		}).map(fav=>{
    			let date = new Date(fav.lastUpdate);
    			return {
    				...fav,
    				likeFrom : fav.likeFrom || [],
    				thumbFrom : fav.likeFrom || [],
    				lastUpdate : date.toLocaleString()
    			};
    		});
    		this.setState({favs:[...results],
    			requestStatus:REQUESTING.LOADED});
    	});
    	this.setState({
    		requestStatus : REQUESTING.FETCHING
    	});
    }
	
    render(){
    	const {render,favs : _,...other} = this.props;
    	const {favs} = this.state;
    	return render({
    		favs,
    		showAllRecipe : this.state.showAllRecipe,
    		handleMoreRecipe : (more)=>()=>{
    			this.setState({
    				showAllRecipe : more
    			});
    		},
    		hasFav : favs.length > 0
    	},
    	other);
    }
}

export default Container;
